import React from 'react'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      onLoggedInQueryCompleted, // via withQueryResults
      setWaiverForms // via withRedux
    } = props

    const handleWaiversQueryCompleted = data => {
      if (!onLoggedInQueryCompleted(data)) {
        return
      }

      if (data && data.viewer) {
        const waivers = data.viewer.waivers
        const waiverForms = waivers
          .filter(w => !w.acceptedBy)
          .map(({ waiverType, title, version }) => ({
            waiverType,
            title,
            version
          }))
        setWaiverForms(waiverForms)
      }
    }

    const handleWaiversMutationCompleted = data => {}

    return (
      <WrappedComponent
        onWaiversQueryCompleted={handleWaiversQueryCompleted}
        {...props}
      />
    )
  }
}

export default withEventHandlers
